import { SearchWithFilter } from 'components/search'

const UndersokelsesmetodePage = () => {
	return <SearchWithFilter />
}

export default UndersokelsesmetodePage
